import styled from "styled-components";

export const ToolItemWithBorder = styled.span<{ $shouldShow: boolean }>`
    display: ${(props) => (props.$shouldShow ? `visible` : `none`)};
    padding: 5px;
    border-radius: 3px;
    border: 1px dotted #c0c0c017;
    &:hover {
        border: 1px solid #c0c0c070;
    }
`;
